export default "__VITE_ASSET__DW3NLH8P__"